<template>
  <div>
    <KpisPreTable
      v-if="showPreTable"
      :group-ids="preTablePayload.groupIds"
      :project-id="preTablePayload.projectId"
      :activity-id="preTablePayload.activityId"
      @backToGroups="closeWeekly"
      @showKpiTable="onShowKpiTable"
      @showKpiCharts="onShowKpiCharts"
      @ActivityHomeShowFullWidth="onShowFullWidth"
    />
    <KpiTable
      v-if="showKpiTable"
      v-bind="kpiTablePayload"
      @back-to-kpi-pretable="closePretable"
    />
    <KpiCharts
      v-if="showKpiCharts"
      v-bind="kpiChartsPayload"
      @back-to-kpi-pretable="closePretable"
    />
    <KpisDailyTable
      v-if="showKpiDailyTable"
      v-bind="kpiDailyTablePayload"
      @back="closeDaily"
    />
  </div>
</template>

<script>
import KpisPreTable from './kpis-pretable.vue'
import KpiTable from './kpis-table.vue'
import KpiCharts from './kpis-charts.vue'
import KpisDailyTable from './kpis-daily/kpi-table.vue'

export default {
  name: 'KpiFlowManager',
  components: {
    KpisPreTable,
    KpiTable,
    KpiCharts,
    KpisDailyTable
  },
  props: {
    initialPayload: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showPreTable: false,
      preTablePayload: {},
      lastPreTablePayload: {},
      showKpiTable: false,
      kpiTablePayload: {},
      showKpiCharts: false,
      kpiChartsPayload: {},
      showKpiDailyTable: false,
      kpiDailyTablePayload: {},
      isDaily: false
    }
  },
  watch: {
    initialPayload: {
      handler(val) {
        if (val) {
          this.onShowFullWidth(val);
        }
      },
      immediate: true
    }
  },
  methods: {
    onShowFullWidth(payload) {
      if (payload.type === 'daily') {
        this.kpiDailyTablePayload = payload;
        this.showKpiDailyTable = true;
        this.showPreTable = false;
        this.showKpiTable = false;
        this.showKpiCharts = false;
        this.isDaily = true;
      } else {
        this.preTablePayload = payload;
        this.lastPreTablePayload = payload;
        this.showPreTable = true;
        this.showKpiTable = false;
        this.showKpiCharts = false;
        this.showKpiDailyTable = false;
        this.isDaily = false;
      }
    },
    onShowKpiTable(payload) {
      this.kpiTablePayload = payload;
      this.showPreTable = false;
      this.showKpiTable = true;
      this.showKpiCharts = false;
      this.showKpiDailyTable = false;
      this.isDaily = false;
    },
    onShowKpiCharts(payload) {
      this.kpiChartsPayload = payload;
      this.showPreTable = false;
      this.showKpiTable = false;
      this.showKpiCharts = true;
      this.showKpiDailyTable = false;
      this.isDaily = false;
    },
    closeWeekly() {
      this.resetAll();
      this.$emit('closeWeekly');
    },
    closeDaily() {
      this.resetAll();
      this.$emit('closeDaily');
    },
    closePretable() {
      this.showPreTable = true;
      this.showKpiTable = false;
      this.showKpiCharts = false;
      this.showKpiDailyTable = false;
      this.kpiTablePayload = {};
      this.kpiChartsPayload = {};
      this.kpiDailyTablePayload = {};
      this.preTablePayload = this.lastPreTablePayload || {};
      this.isDaily = false;
    },
    resetAll() {
      this.showPreTable = false;
      this.showKpiTable = false;
      this.showKpiCharts = false;
      this.showKpiDailyTable = false;
      this.preTablePayload = {};
      this.kpiTablePayload = {};
      this.kpiChartsPayload = {};
      this.kpiDailyTablePayload = {};
      this.lastPreTablePayload = {};
      this.isDaily = false;
    }
  }
}
</script>